module.exports = __webpack_public_path__ + "img/approveAttach.be23db54.svg";